import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Picnic table, 2x1 tiles: a plank top with a bench seat on each side,
// carried by two A-frame ends of angled legs.
const PLANK = "#c8975a";
const PLANK_DARK = "#b0824a";

/** One A-frame end at the given x: two legs splayed along Z + a seat brace. */
function aFrame(x: number): Part[] {
  return [
    {
      geometry: new THREE.BoxGeometry(0.09, 0.85, 0.07),
      color: PLANK_DARK,
      position: [x, 0.38, 0.2],
      rotation: [-0.52, 0, 0],
    },
    {
      geometry: new THREE.BoxGeometry(0.09, 0.85, 0.07),
      color: PLANK_DARK,
      position: [x, 0.38, -0.2],
      rotation: [0.52, 0, 0],
    },
    // Horizontal brace carrying both bench seats.
    {
      geometry: new THREE.BoxGeometry(0.08, 0.06, 1.15),
      color: PLANK_DARK,
      position: [x, 0.41, 0],
    },
  ];
}

export const picnicTable = defineModel({
  id: "picnic-table",
  batchId: "modern",
  name: "Picnic table",
  tags: ["modern", "outdoor", "garden", "park", "seating", "table"],
  summary: "A plank picnic table with attached bench seats.",
  description:
    "A picnic table of the Modern Living kit, spanning 2x1 tiles: a plank " +
    "top and two attached bench seats on A-frame ends of angled legs. Sit on " +
    "either side.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      ...aFrame(-0.62),
      ...aFrame(0.62),
      // Table top.
      {
        geometry: new THREE.BoxGeometry(1.7, 0.06, 0.68),
        color: PLANK,
        position: [0, 0.75, 0],
      },
      // Bench seats.
      {
        geometry: new THREE.BoxGeometry(1.7, 0.05, 0.24),
        color: PLANK,
        position: [0, 0.465, 0.47],
      },
      {
        geometry: new THREE.BoxGeometry(1.7, 0.05, 0.24),
        color: PLANK,
        position: [0, 0.465, -0.47],
      },
    ];
  },
  animations: [],
});
